import { createRootRoute, Outlet } from '@tanstack/react-router'
import { PostHogProvider } from '@/lib/posthog'
import { NotFoundPage } from '@/routes/404'

export const Route = createRootRoute({
  component: () => (
    <PostHogProvider>
      <Outlet />
    </PostHogProvider>
  ),
  notFoundComponent: NotFoundPage,
})
